// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a575d4cb","453":"e12a4215","667":"7989b1f2","977":"48105b97"}[chunkId] + ".chunk.js";
};